import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block text-sm font-medium leading-6 text-gray-900" }
const _hoisted_2 = { class: "font-normal text-gray-600" }
const _hoisted_3 = {
  key: 0,
  class: "pl-2 font-normal text-xs text-red"
}
const _hoisted_4 = { class: "flex items-center gap-2" }

import { XMarkIcon } from "@heroicons/vue/24/solid";
import { FieldArray, FieldEntry, useFieldError } from "vee-validate";
import FileInputAddProject from "@/views/dashboard/components/FileInputAddProject.vue";

type FileEntry = {
  size: number;
  name: string;
  file_base64: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FileInputAddProjectField',
  props: {
  name: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const filesError = useFieldError(props.name);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FieldArray), { name: __props.name }, {
    default: _withCtx(({ fields, remove }) => [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t(`project.add.layout_plans`)) + " ", 1),
        _createElementVNode("span", _hoisted_2, "(" + _toDisplayString(_ctx.$t(`project.add.optional`)) + ")", 1),
        (_unref(filesError))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(filesError)), 1))
          : _createCommentVNode("", true),
        _createVNode(FileInputAddProject, { name: __props.name }, null, 8, ["name"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields as FieldEntry<FileEntry>[], (file, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(file.value.name), 1),
              _createVNode(_unref(XMarkIcon), {
                onClick: ($event: any) => (remove(index)),
                class: "h-4 w-4 a:text-red-500 cursor-pointer",
                "aria-hidden": "true"
              }, null, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["name"]))
}
}

})